import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PRO_Clase = _resolveComponent("PRO_Clase")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_PRO_Categorii = _resolveComponent("PRO_Categorii")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "4" }, {
        default: _withCtx(() => [
          _createVNode(_component_PRO_Clase, { onSelectionChanged: $options.handleSelectionChanged }, null, 8, ["onSelectionChanged"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "8" }, {
        default: _withCtx(() => [
          _createVNode(_component_PRO_Categorii, { ClasaID: $data.selectedRow }, null, 8, ["ClasaID"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}